import { Link, isRouteErrorResponse, useRouteError } from "react-router-dom";

export function RouteErrorPage() {
  const error = useRouteError();
  const status = isRouteErrorResponse(error) ? error.status : null;
  const title = status === 404 ? "页面不存在" : "页面加载失败";
  const detail = isRouteErrorResponse(error)
    ? error.statusText
    : error instanceof Error
      ? error.message
      : "暂时无法确定失败原因。";

  return (
    <main id="main-content" tabIndex={-1}>
      <section role="alert" aria-labelledby="route-error-title">
        <p>{status ? `HTTP ${status}` : "ROUTE ERROR"}</p>
        <h1 id="route-error-title">{title}</h1>
        <p>{detail}</p>
        <Link to="/calendar">返回课程</Link>
      </section>
    </main>
  );
}
